import styled from "styled-components";

export const StyledLogo = styled.figure`
    width: 300px;
    position: relative;
    top: -200px;
    left: -60px;
  
  img {
    width: 300px;
  }
`